import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import Languages from "lang";
import { LANGUAGES } from "util/Constant";

const resources = Languages;

// Dedicated instance via createInstance() - never touches react-i18next's shared
// ambient "default instance" pointer that a bare useTranslation() falls back to.
// Paired with <I18nextProvider i18n={i18n}> around our own tree in AppInitializer,
// this remote's translations are fully isolated from whatever the host (or any
// other remote) does with its own i18n.init() call.
const i18n = i18next.createInstance();

i18n.use(initReactI18next).init({
  resources,
  lng: LANGUAGES.EN,
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

console.log("[i18n:synthia-admin] private i18next instance created + initialized, lng=" + LANGUAGES.EN);

export default i18n;
